<template>
  <div class="overflow-hidden">
    <div class="md:px-10 px-5">
      <div
        class="font-normal flex justify-between text-primary mb-0 mt-1 text-3xl"
      ></div>
      <div class="relative">
        <template>
          <div>
            <holding-transactions v-if="isDepositTransactions" />
            <div class="w-full">
              <transfer-transactions v-if="isTransferTransactions" />
            </div>
            <div>
              <swap-transactions v-if="isSwapTransactions" />
            </div>
          </div>
        </template>
      </div>
      <transaction-dialog
        v-if="showTransactionDialog"
        :showDialog="showTransactionDialog"
        @closeDialog="closeDialog"
        :transaction="currentTransaction"
        :rateIncreased="transactionHasRateChange"
        @showDepositDetails="showDepositDetails"
        @showDepositType="showDepositType"
      />
      <initiate-tour-button
        @startTour="startTransactionsTour"
        v-if="isDepositTransactions"
      />
      <app-tour
        :tourDetails="transactionsTour"
        tourComponent="transaction"
        :displayTour="displayTour"
        @stopTour="stopTour"
      />
    </div>
  </div>
</template>

<script>
import refreshToken from '@/mixins/refreshToken.js'
import { TRANSACTIONS_TOUR } from '@/utils/constants'
import fetchAllTours from '@/mixins/appTourApi.js'
import accesses from '@/mixins/app.js'
import eventBus from '@/global/eventBus'
import logout from '@/mixins/logout.js'
import localDeposit from '@/mixins/localDeposit.js'
import tenant from '@/mixins/tenant.js'
import transactions from '@/mixins/transactions.js'
import notification from '@/mixins/notification.js'
import { ParseMoney, ParseMoneyAll } from '@/utils/helpers'

export default {
  mixins: [
    refreshToken,
    logout,
    localDeposit,
    transactions,
    accesses,
    tenant,
    fetchAllTours,
    notification
  ],
  name: 'Transactions',
  data () {
    return {
      form: {
        transactionOption: ''
      },
      displayTour: false,
      transactionsTour: TRANSACTIONS_TOUR,
      options: [
        'All Time report',
        '7 days report',
        '30 days report',
        '90 days report'
      ],
      activeNames: [],
      showTransactionDialog: false,
      value: 'All Time report',
      transactionHasRateChange: false,
      isLoadingTransactions: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  components: {
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    TransactionDialog: () => import('@/components/app/TransactionDialog.vue'),
    SwapTransactions: () =>
      import('@/components/v2/bridge/layout/SwapTransactions.vue'),
    HoldingTransactions: () =>
      import('@/components/v2/transactions/layout/HoldingTransactions.vue'),
    TransferTransactions: () =>
      import('@/components/v2/transactions/layout/Transfers.vue')
  },
  methods: {
    handleOpenFromNotification () {
      if (this.isNotificationRoute) {
        if (
          this.notificationType === this.$transactionType.WITHDRAWAL ||
          this.notificationType === this.$transactionType.CURRENCY_SWAP
        ) {
          this.activeFilter = this.$transactionType.DEPOSIT
        } else {
          this.activeFilter = this.notificationType
        }
      }
    },
    startTransactionsTour () {
      this.$tours.transactionsTour.start()
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
    },
    goToRoute (route) {
      this.$router.push({ name: route })
    },
    showDepositDetails () {
      eventBus.$emit('depositDetailsEvent')
    },
    showDepositType () {
      eventBus.$emit('depositType')
    },
    showTransaction (transaction) {
      this.$store.dispatch('transactions/setCurrentTransaction', transaction)
      this.currentTransaction = transaction
      this.transactionHasRateChange = this.rateIncreased(transaction)
      this.showTransactionDialog = true
    },
    closeDialog () {
      this.showTransactionDialog = false
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    }
  },
  computed: {
    isANewUser () {
      return !this.$store.state.appTour.allTours.transaction
    },
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    isSwapTransactions () {
      return this.activeFilter === 'swap'
    },
    isDepositTransactions () {
      return this.activeFilter === 'deposit'
    },
    isTransferTransactions () {
      return this.activeFilter === 'transfer'
    },
    activeFilter: {
      get () {
        return this.$store.state.transactions.activeFilter
      },
      set (value) {
        this.$store.dispatch('transactions/activeFilter', value)
      }
    },
    latestTransactions () {
      return this.$store.state.transactions?.transactions?.items || []
    },
    page () {
      return this.$store.state.transactions.transactions.page
    },
    noTransactions () {
      return !this.latestTransactions.length > 0
    }
  },
  watch: {
    '$route.params.type': {
      handler: function (newValue) {
        if (newValue) {
          if (
            newValue === this.$transactionType.WITHDRAWAL ||
            newValue === this.$transactionType.CURRENCY_SWAP
          ) {
            this.activeFilter = this.$transactionType.DEPOSIT
          } else {
            this.activeFilter = newValue
          }
        }
      },
      immediate: true
    }
  },
  async mounted () {
    await this.fetchAllTours()
    if (this.isANewUser && this.isDepositTransactions) {
      this.startTransactionsTour()
    }
    this.getAllNotifications()
    this.isLoadingTransactions = true
    this.handleOpenFromNotification()
    this.payload.type = this.activeFilter
    this.getTransactions()
  },
  beforeDestroy () {
    this.$store.dispatch('transactions/activeFilter', 'deposit')
  }
}
</script>

<style scoped>
.el-select-dropdown__item.selected {
  color: var(--color-primary);
  font-weight: bold;
  background: var(--background-8);
}

.text-root-1 {
  color: var(--text-1);
}

.bg-root {
  background: var(--background);
}

.statement-container {
  background: var(--background);
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 8px;
}

.rounded-40px {
  border-radius: 40px;
}

.bottom-9p {
  bottom: 12%;
}

>>> .el-collapse-item__header {
  height: 58px !important;
}

>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important;
}

>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
  /* color: var(--color-primary) !important ; */
}

.t-card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}

>>> .el-collapse-item__content {
  padding-bottom: 0px;
}

>>> .el-input--suffix .el-input__inner {
  border-radius: 12px;
}

>>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: var(--background-2) !important;
}

.bg-root-1 {
  background: var(--background-1);
}

.bg-root-2 {
  background: var(--background-2);
}

>>> .el-input__inner {
  border: none !important;
  background: var(--background);
  color: var(--root-2);
}

>>> .el-select .el-input .el-select__caret {
  color: var(--color-primary);
}

>>> .el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background: green !important;
}

>>> .btn-prev {
  background: var(--background-2) !important;
}

/* .scrollbar {
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
} */
.scrollbar::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.minheight {
  min-height: 48vh;
}

.spinner-height {
  height: 42.6vh;
}

@media screen and (max-width: 768px) {
  >>> .el-input--suffix .el-input__inner {
    font-size: 0.7rem !important;
  }
}
</style>
